import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import {
  AffiliateReferralDetail,
  AffiliateReferralReport,
  AffiliateReferralReportParams,
  CustomerReferralDetail,
  CustomerReferralReport,
  CustomerReferralReportParams,
  ReferralAnalytics,
} from './referralReports.types';

export interface ReferralAnalyticsParams {
  userTypeId: string;
}

const getReferralAnalytics = (client: AxiosInstance) => async (params: ReferralAnalyticsParams) => {
  const response = await client.get<ApiResponse<ReferralAnalytics>>(API_ROUTES.GET_REFERRAL_ANALYTICS, { params });
  return response.data;
};
const list = <T>(client: AxiosInstance, path: string, params: AffiliateReferralReportParams) =>
  client.get<PaginatedApiResponse<T[]>>(path, { params }).then((r) => r.data);
export const getCustomerReferralDetails = (client: AxiosInstance) => (params: AffiliateReferralReportParams) =>
  list<CustomerReferralDetail>(client, API_ROUTES.GET_AFFILIATE_REFERRAL_CUSTOMER_DETAILS, params);
export const getAffiliateReferralDetails = (client: AxiosInstance) => (params: AffiliateReferralReportParams) =>
  list<AffiliateReferralDetail>(client, API_ROUTES.GET_AFFILIATE_REFERRAL_AFFILIATE_DETAILS, params);

export const getAffiliateReferralReport = (client: AxiosInstance) => async (params: AffiliateReferralReportParams) => {
  return (
    await client.get<PaginatedApiResponse<AffiliateReferralReport[]>>(API_ROUTES.GET_AFFILIATE_REFERRAL_REPORT, {
      params,
    })
  ).data;
};

export const getCustomerReferralReport = (client: AxiosInstance) => async (params: CustomerReferralReportParams) =>
  (
    await client.get<PaginatedApiResponse<CustomerReferralReport[]>>(API_ROUTES.GET_CUSTOMER_REFERRAL_REPORT, {
      params,
    })
  ).data;

export const referralReportQueries = {
  all: () => ['referral-reports'],
  analytics: (params: ReferralAnalyticsParams) =>
    queryFactoryOptions<ApiResponse<ReferralAnalytics>>({
      queryKey: [...referralReportQueries.all(), 'analytics', params],
      queryFn: (client) => () => getReferralAnalytics(client)(params),
    }),
  customerList: (params: CustomerReferralReportParams) =>
    queryFactoryOptions({
      queryKey: [...referralReportQueries.all(), 'customer-list', params],
      queryFn: (client) => () => getCustomerReferralReport(client)(params),
    }),
  affiliateList: (params: AffiliateReferralReportParams) =>
    queryFactoryOptions<PaginatedApiResponse<AffiliateReferralReport[]>>({
      queryKey: [...referralReportQueries.all(), 'affiliate-list', params],
      queryFn: (client) => () => getAffiliateReferralReport(client)(params),
    }),
  customerDetails: (params: AffiliateReferralReportParams) =>
    queryFactoryOptions({
      queryKey: [...referralReportQueries.all(), 'customer-details', params],
      queryFn: (client) => () => getCustomerReferralDetails(client)(params),
    }),
  affiliateDetails: (params: AffiliateReferralReportParams) =>
    queryFactoryOptions({
      queryKey: [...referralReportQueries.all(), 'affiliate-details', params],
      queryFn: (client) => () => getAffiliateReferralDetails(client)(params),
    }),
};
